<template>
  <div class="mt-8 mb-4">
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-2xl font-bold">Related Tools</h2>
      <router-link
        class="hover:bg-gray-300 hover:no-underline p-4 px-2 py-1 text-sm text-center bg-gray-200 rounded"
        :to="{ name: 'tools' }"
        title="All Cycling Tools"
      >
        All Tools &rarr;
      </router-link>
    </div>

    <div class="md:grid-cols-2 grid grid-cols-1 gap-4">
      <router-link
        v-for="tool in relatedTools"
        :key="tool.route"
        :to="{ name: tool.route }"
        :title="tool.linkTitle"
        class="hover:border-gray-400 hover:no-underline block p-5 py-4 bg-white border rounded-lg"
      >
        <div class="flex items-center gap-2 mb-1">
          <svg class="svg-icon svg-icon--sm" :class="tool.color">
            <use :xlink:href="`#icon-${tool.icon}`"></use>
          </svg>
          <h4 class="mb-0 text-base font-bold">{{ tool.title }}</h4>
        </div>
        <p class="text-muted text-sm">{{ tool.description }}</p>
      </router-link>
    </div>
  </div>
</template>

<script>
import { toolsList } from 'data/toolsList'

export default {
  name: 'RelatedTools',
  props: {
    // Array of tool route names (e.g. 'tools.ftp') in display order.
    tools: {
      type: Array,
      required: true
    }
  },
  computed: {
    // Resolve route names to the shared toolsList entries (single source of truth
    // for title, icon, colour, and description) and drop any that don't match.
    relatedTools() {
      return this.tools.map((route) => toolsList.find((t) => t.route === route)).filter(Boolean)
    }
  }
}
</script>
